import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Image } from '@chakra-ui/image';
import ObtainlyLogoText from 'src/core/assets/images/obtainly-logo.svg';
export var Logo = function () {
    return _jsx(Image, { src: ObtainlyLogoText }, void 0);
};
